"use strict";

// observer.js — スクロール表示監視（1回きり）
(() => {
  const defer = window.queueMicrotask
    ? window.queueMicrotask.bind(window)
    : (callback) => window.setTimeout(callback, 0);

  const initOneShotObserver = () => {
    const selectors = [".u-animation--fadeIn", ".u-animation--appear", ".u-animation--scale"];
    const targets = document.querySelectorAll(selectors.join(", "));

    if (!targets.length || !("IntersectionObserver" in window)) {
      return;
    }

    const onEnter = (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add("js-show");
        obs.unobserve(entry.target);
      });
    };

    const observer = new IntersectionObserver(onEnter, {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    });

    const soonObserver = new IntersectionObserver(onEnter, {
      root: null,
      rootMargin: "0px",
      threshold: 0.05,
    });

    targets.forEach((el) => {
      (el.hasAttribute("data-observer-soon") ? soonObserver : observer).observe(el);
    });
  };

  const initOnceObserver = () => {
    const onceTargets = document.querySelectorAll("[data-observer-once]");

    if (!onceTargets.length) {
      return;
    }

    if (!("IntersectionObserver" in window)) {
      onceTargets.forEach((el) => {
        el.dispatchEvent(new CustomEvent("observer:enter"));
      });
      return;
    }

    const onceObserver = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.dispatchEvent(
            new CustomEvent("observer:enter", {
              detail: { entry },
            })
          );
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      }
    );

    onceTargets.forEach((el) => onceObserver.observe(el));
  };

  const initObserver = () => {
    document.documentElement.classList.add("js-observer");
    initOneShotObserver();
    defer(initOnceObserver);
  };

  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) {
      return;
    }

    defer(initOnceObserver);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initObserver, { once: true });
  } else {
    initObserver();
  }
})();
